import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import {
  RISK_PROFILE_LIST,
  RISK_PROFILE_CREATE,
  RISK_PROFILE_EDIT,
} from "./RiskProfile.constants";

const RiskProfileList = Loadable(
  lazy(() =>
    import("./RiskProfileList").then(({ RiskProfileList }) => ({
      default: RiskProfileList,
    }))
  )
);

const RiskProfileForm = Loadable(
  lazy(() =>
    import("./RiskProfileFormV2").then(({ RiskProfileFormV2 }) => ({
      default: RiskProfileFormV2,
    }))
  )
);

export const RiskProfileRootRoutes = [
  {
    path: `${RISK_PROFILE_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <RiskProfileList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RISK_PROFILE_CREATE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <RiskProfileForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${RISK_PROFILE_EDIT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <RiskProfileForm />
      </AuthorizedRoute>
    ),
  },
];
